/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Conversations_LoadingInputs */



/**
* | output |
* | --- |
* | "Loading your conversations…" |
*
* @param {Conversations_LoadingInputs} inputs
* @param {{ locale?: "en" | "nl" | "fr" }} options
* @returns {LocalizedString}
*/
export const conversations_loading = /** @type {((inputs?: Conversations_LoadingInputs, options?: { locale?: "en" | "nl" | "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Conversations_LoadingInputs, { locale?: "en" | "nl" | "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return /** @type {LocalizedString} */ ("Je gesprekken worden geladen…")
	if (locale === "fr") return /** @type {LocalizedString} */ ("Chargement de vos conversations…")
	return /** @type {LocalizedString} */ ("Loading your conversations…")
});